import { Stack as MStack, StackProps } from '@mui/material'

export const Stack: React.FC<StackProps> = (props) => {
  return <MStack {...props} />
}
